module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAWCAMAAAACYceEAAAAYFBMVEUAAABvb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29P7MuoAAAAH3RSTlMA9GVR8u7cDgW2eTAkGebPoXBrYEbAo5xYORP3xMIcY4mYeAAAAI5JREFUKM+tzecKwyAUhmGNK8Y9srq8/7ssESqelFIo/f6cFx5E9PvUypmV2ztM1zmQtGApzlBIvZrfRgDqgDqDJyD+3jJY8IjHlhqrXmhuKVjuxW4tDd57kUtLQi+9kKJf6TwCk/xR77hiAUXMLGhhiKM0Ibhx4phR5k0qAzqbyvvx+dAI7hvFTxQd+v+enMgFYbRAYHoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/search.png
// module id = p1AH
// module chunks = 0